import { render } from "./NewCreditNote.vue?vue&type=template&id=440fce9a&scoped=true"
import script from "./NewCreditNote.vue?vue&type=script&lang=js"
export * from "./NewCreditNote.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440fce9a"]])

export default __exports__